module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"input_is_required":"Please enter content","confirm":"Confirm","cancel":"Cancel","close":"Close"},"zh":{"input_is_required":"請輸入文字","confirm":"確認","cancel":"取消 ","close":"關閉"}}')
  delete Component.options._Ctor
}
